import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import LoginPanel from './LoginPanel';
import useAuthentication from '../hooks/useAuthentication';

function Login() {
    const location = useLocation();
    const { isUserLoggedIn } = useAuthentication();
    let result;
    if (isUserLoggedIn) {
        result = <Redirect to={(location.state && location.state.from) ? location.state.from : '/'} />;
    } else {
        result = <LoginPanel />;
    }
    return result;
}

export default Login;
